import AttendanceForm from './Attendance';

const CheckIn = () => {
  return <AttendanceForm type="checkin" />
};

export default CheckIn;
